/**
 * 저장 알림장 재진입 시 예약 발송 시각 복원 규칙.
 *
 * - 분 선택지는 10분 단위뿐이므로 10분 단위로 올림한다. (13:59 → 14:00)
 * - 이미 지난 예약 시각은 복원하지 않는다(null). 지난 시각을 토글 ON 으로 복원하면
 *   사용자가 '즉시 발송'을 눌러도 과거 예약으로 다시 저장돼 발송되지 않은 채 저장 알림장에 남는다.
 */
export interface RestoredReservationTime {
  date: Date;
  hour: string;
  minute: string;
}

const pad2 = (n: number) => n.toString().padStart(2, "0");

export const restoreReservationTime = (
  dtReservation?: string | null,
  reservationSendFlag?: boolean,
  now: Date = new Date()
): RestoredReservationTime | null => {
  if (!dtReservation || !reservationSendFlag) return null;

  const parsed = new Date(dtReservation);
  if (Number.isNaN(parsed.getTime())) return null;

  const rounded = new Date(parsed);
  rounded.setSeconds(0, 0);
  const minute = rounded.getMinutes();
  if (minute % 10 !== 0) {
    // setMinutes 는 60 이상이면 시간을 자동으로 올린다
    rounded.setMinutes(Math.ceil(minute / 10) * 10);
  }

  if (rounded.getTime() <= now.getTime()) return null;

  return {
    date: rounded,
    hour: pad2(rounded.getHours()),
    minute: pad2(rounded.getMinutes()),
  };
};
